import React, { useState } from 'react';



const ContactForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(null); 

  const handleNameChange = (e) => setName(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleMessageChange = (e) => setMessage(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      name,
      email,
      message,
    };

    try {
      const response = await fetch('https://7wlzmrbv6f.execute-api.me-south-1.amazonaws.com/developed/contact_us', {
        method: 'POST', 
        mode: 'cors',
         credentials: 'include',
        headers: {
          'Content-Type': 'application/json', 

        },
       
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message
        }), 
      });
      console.log(response)

      if (!response.ok) {
        setStatus('Something went wrong, please try again.');
      } else {
          setStatus('Your message has been sent successfully!');

      }
    } catch (error) {
      setStatus('Something went wrong, please try again.');
    }

    setName('');
    setEmail('');
    setMessage('');
  };

  return (
    
    <div className="contact-form-container">
    <div className='module-title'>Contact us</div>

    <div className="sub-container-form">

    <img src="/mainImages/extras/contact.jpg" alt="contact us " className='contact-image'></img>
      <form onSubmit={handleSubmit} className="contact-form">

<div className="contact-details">
  <h3>Our Office</h3>
  <p>
    Tamouh Tower, Building 12, 22nd Floor, Office C1, Marina Square - Abu Dhabi
  </p>

  <a 
    href="https://wa.me/+971547298091" 
    target="_blank" 
    rel="noopener noreferrer" 
    className="whatsapp-link"
  >
    💬 Chat with us on WhatsApp
  </a>
</div>

                  <p>If you have any questions, please feel free to reach out to us!</p>

        <div className="form-group-contact">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={handleNameChange}
            required
          />
        </div>

        <div className="form-group-contact">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={handleEmailChange}
            required
          />
        </div>

        <div className="form-group-contact">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            value={message}
            onChange={handleMessageChange}
            required
          />
        </div>
<div className="form-button">
        <button  type="submit">Send</button>
        </div>
      </form>
    </div>

  

      {status && <p className="status-message">{status}</p>}
      </div>
  );
};

export default ContactForm;
